import PropTypes from "prop-types";
import { useState } from "react";
import CustomMoreOptions from "@/components/specific/Custom_More_Options";
import WebIcon from "@/components/common/Web_Icons";
import SingleMediaPhoto from "@/pages/media_manager/Single_Media_Photo";
import MediaDialog from "@/pages/media_manager/components/Media_Dialog";
import { Dropdown } from "antd";

const MediaCard = ({
  _id,
  title,
  description,
  date,
  author,
  imageFiles,
  videoFiles,
  documentFiles,
  onDelete,
}) => {
  const [isMediaDialogOpen, setIsMediaDialogOpen] = useState(false);
  const [showEditDialog, setShowEditDialog] = useState(false);

  const handleCardClick = (e) => {
    if (e.target.closest("button")) return;
    setIsMediaDialogOpen(true);
  };

  const handleMoreOptionsClick = (e) => {
    e?.stopPropagation?.();
  };

  const handleEdit = ({ domEvent } = {}) => {
    domEvent?.stopPropagation?.();
    setShowEditDialog(true);
  };

  const handleDelete = ({ domEvent } = {}) => {
    domEvent?.stopPropagation?.();
    onDelete(_id, title);
  };

  const handleCloseDialog = () => {
    setIsMediaDialogOpen(false);
  };

  const truncateText = (text, maxLength = 45) => {
    return text?.length > maxLength ? text.slice(0, maxLength) + "..." : text;
  };

  const mediaData = {
    _id: _id,
    name: title,
    description,
    imageFiles,
    videoFiles,
    documentFiles,
    userID: author,
    createdAt: date,
  };

  const getFileTypeIcon = () => {
    if (imageFiles?.length > 0) {
      return "ImageUpload";
    } else if (videoFiles?.length > 0) {
      return "VideoUpload";
    } else if (documentFiles?.length > 0) {
      return "DocumentUpload";
    }
    return "PDF"; // Default fallback
  };

  return (
    <>
      <div
        className="rounded-lg bg-[var(--header-bg)] transition-all duration-300 p-4 cursor-pointer"
        onClick={handleCardClick}>
        <div className="flex items-start gap-4">
          <div className="flex items-center justify-center flex-shrink-0 w-12 h-12 rounded-lg bg-secondary">
            <WebIcon icon={getFileTypeIcon()} size="large" />
          </div>

          <div className="flex-grow min-w-0">
            <div className="flex items-start justify-between gap-2">
              <div className="flex flex-col min-w-0">
                <h3 className="overflow-hidden text-bold-x text-lightestGrey whitespace-nowrap text-ellipsis">
                  {truncateText(title)}
                </h3>
                <p className="mt-1 overflow-hidden text-left text-regular text-lighterGrey whitespace-nowrap text-ellipsis">
                  {truncateText(description)}
                </p>
                <span className="mt-1 text-left text-small text-lighterGrey">
                  {date}
                </span>
              </div>

              <button
                className="flex-shrink-0 p-2 rounded-full hover:bg-gray-100"
                onClick={handleMoreOptionsClick}>
                <Dropdown
                  menu={{
                    items: [
                      {
                        key: "modify",
                        label: "Modify",
                        onClick: handleEdit,
                      },
                      {
                        key: "delete",
                        label: "Delete",
                        onClick: handleDelete,
                      },
                    ],
                  }}
                  trigger={["click"]}>
                  <CustomMoreOptions
                    variant="filled"
                    orientation="vertical"
                    onClick={(e) => e?.stopPropagation?.()}
                  />
                </Dropdown>
              </button>
            </div>
          </div>
        </div>
      </div>

      <SingleMediaPhoto
        isVisible={isMediaDialogOpen}
        onClose={handleCloseDialog}
        mediaData={mediaData}
      />

      <MediaDialog
        isVisible={showEditDialog}
        onClose={() => {
          setShowEditDialog(false);
        }}
        mediaData={mediaData}
      />
    </>
  );
};

MediaCard.propTypes = {
  _id: PropTypes.string,
  title: PropTypes.string,
  description: PropTypes.string,
  date: PropTypes.string,
  author: PropTypes.string,
  imageFiles: PropTypes.arrayOf(PropTypes.string),
  videoFiles: PropTypes.arrayOf(PropTypes.string),
  documentFiles: PropTypes.arrayOf(PropTypes.string),
  onDelete: PropTypes.func,
};

export default MediaCard;
